document.addEventListener("DOMContentLoaded", function () {
  let div = document.getElementById("sticky-button");
  if (!div) return;

  let container = div.parentElement;

  function updatePosition() {
    let containerRect = container.getBoundingClientRect();
    let divRect = div.getBoundingClientRect();

    container.style.height = div.offsetHeight + "px"; // Ensure container maintains height

    if (containerRect.bottom <= window.innerHeight) {
      div.classList.remove("sticky-fixed");
      div.classList.add("sticky-absolute");
    } else {
      div.classList.remove("sticky-absolute");
      div.classList.add("sticky-fixed");
    }
  }

  window.addEventListener("scroll", updatePosition);
});